export default "./dist/stdassets/images/icons/view-forward.png";